import React from "react";
import styled, { keyframes, css } from "styled-components/macro";
import MammothIcon from "icons/MammothIcon";
import SubscriptionScreen from "root/profile/subscription/SubscriptionScreen";
import { useSetState } from "components/ReduxProvider";
import { SALE } from "sharedJs__generated/constants";

export const BfslideIn = keyframes`
  0% {
    left: -130%;
  }
  100% {
    left: 0; 
  }
`;

const Wrapper = styled.div<{ $isVisible?: boolean }>`
  position: absolute;
  top: 0;
  left: -130%;
  width: 100%;
  height: 100%;
  background: black;
  color: white;
  z-index: 1200;
  will-change: left;
  ${({ $isVisible }) =>
    $isVisible &&
    css`
      animation: ${BfslideIn} 1.3s ease-out forwards;
    `}
`;

const MammothDragger = styled.div<{ $isVisible?: boolean }>`
  position: absolute;
  right: -100px;
  top: 50%;
  z-index: 12;
  transform: translateY(-50%);
`;

const SMammothIcon = styled(MammothIcon)`
  width: 100px;
  height: 100px;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
`;

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.5;
  z-index: 11;
  animation: ${fadeIn} 1s ease-out;
`;

const AllWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 50;
`;

const SaleMainBlackFriday = () => {
  const [isVisible, setIsVisible] = React.useState(false);
  const setLastSeen = useSetState("saleMainDialogLastSeen");
  const setCloseSale = useSetState("closeSale");
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);
    const wrapper = wrapperRef.current;

    return () => {
      clearTimeout(timer);
      // Force Safari to clean up compositing layer on unmount
      if (wrapper) {
        wrapper.style.display = "none";
        // Force repaint
        void wrapper.offsetHeight;
      }
    };
  }, []);

  return (
    <AllWrap>
      <Backdrop />
      <Wrapper ref={wrapperRef} $isVisible={isVisible}>
        <MammothDragger $isVisible={isVisible}>
          <SMammothIcon walking={true} scale={3} />
        </MammothDragger>
        <SubscriptionScreen
          onClose={() => {
            setLastSeen(SALE.blackFriday);
            setCloseSale(true);
          }}
          fromMain={true}
          isAnimating={isVisible}
        />
      </Wrapper>
    </AllWrap>
  );
};

export default SaleMainBlackFriday;
